import React, { useState, useEffect } from "react";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { Auth } from "aws-amplify";
import { BrowserRouter as Router, Redirect } from "react-router-dom";
import "../App.css";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      <Link color="inherit" href="https://uusi.jatti.fi/">
        JAT ry
      </Link>{" "}
      {new Date().getFullYear()}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage:
      "url(https://live.staticflickr.com/657/20612508042_f279183005_k_d.jpg)",
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

function Login() {
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [signUp, setSignUp] = useState(false);
  const [signUpConfirm, setSignUpConfirm] = useState(false);
  const [confirmCode, setConfirmCode] = useState("");
  const [forgotPwd, setForgotPwd] = useState(false);
  const [forgotPwdSent, setForgotPwdSent] = useState(false);
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {}, [isLoggedIn, isLoggingIn, setIsLoggingIn]);

  const classes = useStyles();
  const onKeyPress = (e: any) => {
    if (e.key === "Enter") handleSignIn();
  };
  const handleSignIn = () => {
    Auth.signIn(username.toLowerCase(), password)
      .then((resp) => {
        if (!isLoggedIn) setIsLoggedIn(true);
      })
      .catch((e) => {
        setErrorMessage("Tarkista käyttäjätunnus ja salasana");
      });
  };

  const handleSignUp = () => {
    Auth.signUp(username.toLowerCase(), password)
      .then((resp) => {
        setSignUpConfirm(true);
        setErrorMessage("");
      })
      .catch((e) => {
        setErrorMessage(
          "Tarkista sähköpostiosoite tai salasanan pituus yli 8 merkkiä."
        );
      });
  };

  const handleConfirmSignUp = () => {
    Auth.confirmSignUp(username.toLowerCase(), confirmCode)
      .then((resp) => {
        setSignUpConfirm(false);
        setSignUp(false);
        setErrorMessage("Tunnus luotu, kirjaudu sisään.");
      })
      .catch((e) => {
        setErrorMessage("Tarkista sähköpostiosoite tai varmistuskoodi.");
      });
  };

  const handlePwdForgot = () => {
    Auth.forgotPassword(username.toLowerCase())
      .then((resp) => {
        setForgotPwd(false);
        setForgotPwdSent(true);
        setPassword("");
        setErrorMessage("");
      })
      .catch((e) => {
        setErrorMessage("Koodin lähetys epäonnistui.");
      });
  };

  const handlePwdChange = () => {
    Auth.forgotPasswordSubmit(username.toLowerCase(), confirmCode, password)
      .then((resp) => {
        setForgotPwdSent(false);
        setErrorMessage("Salasana vaihdettu. Kirjaudu sisään");
      })
      .catch((e) => {
        setErrorMessage(
          "Tarkista sähköposti tai salasanan pituus yli 8 merkkiä."
        );
      });
  };

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            JAT Kenttävaraus kirjautuminen
          </Typography>
          {isLoggedIn ? (
            <>
              <Redirect to="/app" />
            </>
          ) : (
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                autoFocus
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyPress={(e) => onKeyPress(e)}
              />
              {!(forgotPwd || signUpConfirm) && (
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Salasana"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyPress={(e) => onKeyPress(e)}
                />
              )}
              {(signUpConfirm || forgotPwdSent) && (
                <div>
                  <p className="errorMessage">
                    Tarkista varmistuskoodi sähköpostistasi.
                    <br />
                    Älä sulje tätä sivua.
                  </p>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="confirmCode"
                    label="Varmistuskoodi"
                    type="text"
                    id="confirmCode"
                    value={confirmCode}
                    onChange={(e) => setConfirmCode(e.target.value)}
                  />
                </div>
              )}
              {forgotPwd ? (
                <Button
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={handlePwdForgot}
                >
                  Uusi salasana
                </Button>
              ) : (
                <>
                  {signUp ? (
                    <>
                      {!signUpConfirm ? (
                        <Button
                          type="button"
                          fullWidth
                          variant="contained"
                          color="primary"
                          className={classes.submit}
                          onClick={handleSignUp}
                        >
                          Luo tunnus
                        </Button>
                      ) : (
                        <Button
                          type="button"
                          fullWidth
                          variant="contained"
                          color="primary"
                          className={classes.submit}
                          onClick={handleConfirmSignUp}
                        >
                          Varmista tunnus
                        </Button>
                      )}
                    </>
                  ) : (
                    <>
                      {!forgotPwdSent ? (
                        <Button
                          type="button"
                          fullWidth
                          variant="contained"
                          color="primary"
                          className={classes.submit}
                          onClick={handleSignIn}
                        >
                          Kirjaudu
                        </Button>
                      ) : (
                        <Button
                          type="button"
                          fullWidth
                          variant="contained"
                          color="primary"
                          className={classes.submit}
                          onClick={handlePwdChange}
                        >
                          Vaihda salasana
                        </Button>
                      )}
                    </>
                  )}
                  <p className="errorMessage">{errorMessage}</p>
                </>
              )}

              <Grid container>
                <Grid item xs>
                  {forgotPwd ? (
                    <Link
                      href="#"
                      variant="body2"
                      onClick={() => setForgotPwd(false)}
                    >
                      En unohtanutkaan salasanaa.
                    </Link>
                  ) : (
                    <Link
                      href="#"
                      variant="body2"
                      onClick={() => {
                        setForgotPwd(true);
                        setErrorMessage("");
                      }}
                    >
                      Unohditko salasanan?
                    </Link>
                  )}
                </Grid>
                <Grid item>
                  {signUp ? (
                    <Link
                      href="#"
                      variant="body2"
                      onClick={() => setSignUp(false)}
                    >
                      {"Kirjaudu sisään käyttäjätunnuksella"}
                    </Link>
                  ) : (
                    <Link
                      href="#"
                      variant="body2"
                      onClick={() => setSignUp(true)}
                    >
                      {"Luo käyttäjätunnus"}
                    </Link>
                  )}
                </Grid>
              </Grid>
              <Box mt={5}>
                <Copyright />
              </Box>
            </form>
          )}
        </div>
      </Grid>
    </Grid>
  );
}

export default Login;
